module.exports = __webpack_public_path__ + "img/blob (1).c7d04efc.svg";